<template>
  <!-- 患者情報詳細 -->
  <div id="AppPatientDetail">
    <!-- 上部余白 -->
    <div style="height: 10px;" />
    <div style="margin-left: 50px; margin-Right: 50px;">
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">患者情報詳細</label>
        </div>
      </div>

      <!-- 詳細表示 -->
      <div style="detailArea">
        <table class="table is-full">
          <table style="width: 100%;">
            <tr>
              <th style="border-bottom: solid 1px; width: 150px;">患者コード</th>
              <td style="border-bottom: solid 1px;" colspan="8">
                {{ data.code }}
                <div style="float:right">
                  <b-button
                    class="button is-primary has-text-centered"
                    icon-left="airplane"
                    native-type="button"
                    v-on:click="gotoTravelSchedule(data)"
                    position="is-right"
                  >国内旅行</b-button>
                  <b-button
                    class="button is-primary has-text-centered"
                    icon-left="alert-circle"
                    native-type="button"
                    v-on:click="gotoUrgentEdit(data)"
                    position="is-right"
                    v-if="this.userInfo.roleId<2"
                  >患者対応</b-button>
                </div>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">患者名（患者名カナ）</th>
              <td style="border-bottom: solid 1px;" colspan="8">
                {{ data.name }}
                <template v-if="data.kana">（{{data.kana}}）</template>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">住所</th>
              <td style="border-bottom: solid 1px;" colspan="8">
                〒{{data.zipCode}} {{ data.address }}
                <b-field class="file" style="float:right">
                  <b-button
                    class="button is-primary has-text-centered"
                    icon-left="google-maps"
                    native-type="button"
                    v-on:click="doShowGoogleMap([
                      {
                          'address': data.address,
                          'name': data.name,
                          'patientZipCode': data.zipCode,
                      }
                      ])"
                  ></b-button>
                  <b-modal :active.sync="isShowGoogleMap" has-modal-card>
                    <googleMap-form v-bind:marker="addressList"></googleMap-form>
                  </b-modal>
                </b-field>
              </td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">電話</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.phone }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">携帯電話</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.mobile }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">緊急連絡先</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.emergencyContact }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">勤務先名</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.employment }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">勤務連絡先</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.employmentContact }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">誕生日</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.birthday }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">年齢</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.age }}</td>
            </tr>
            <tr>
              <th style="border-bottom: solid 1px;">性別</th>
              <td style="border-bottom: solid 1px;" colspan="8">{{ data.gender | genderFilter}}</td>
            </tr>
            <template v-for="(prodItem, index) in data.productList">
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;width: 150px;" rowspan="14">機器情報 {{index + 1}}</th>
                <th style="border-bottom: solid 1px;width: 150px;">機器名</th>
                <td style="border-bottom: solid 1px;" colspan="7">
                  {{ prodItem.productName }} ({{ prodItem.productCode }})
                  <div style="float:right">
                    <b-button
                      style="float:right; margin-right: .2em;"
                      class="button is-primary has-text-centered"
                      native-type="button"
                      v-on:click="prescriptionEdit(data.code,data.name,prodItem)"
                      position="is-right"
                    >処方値参照</b-button>
                    <b-button
                      style="float:right; margin-right: .2em;"
                      class="button is-primary has-text-centered"
                      native-type="button"
                      v-on:click="gotoInspection(prodItem.code,prodItem.productCode,data.code,prodItem.serialNumber)"
                      position="is-right"
                    >点検情報参照</b-button>
                  </div>
                </td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">シリアルNo.</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ prodItem.serialNumber }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">疾患名</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ prodItem.diseaseName }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">療法（呼吸のみ）</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.therapy | therapyFilter }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">感染症</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.Infection | InfectionFilter}}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">直送先種別</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.directDestinationType | directDestinationTypeFilter}}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">処方使用時間（呼吸）</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.usageTime | usageTimeFilter}}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">実使用時間</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ prodItem.elapsedTime }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">医療機関名(医療機関得意先コード)</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.hospitalName }} ({{ prodItem.hospitalCode }})</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">診療科 担当医</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.department }} ({{ prodItem.doctorName }})</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">医療機関電話番号</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ prodItem.hospitalPhone }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">直通電話番号</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ prodItem.directPhone }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">営業所名</th>
                <td
                  style="border-bottom: solid 1px;"
                  colspan="7"
                >{{ prodItem.officeCode | officeFilter((officeMaster)) }}</td>
              </tr>
              <tr v-bind:key="prodItem.index">
                <th style="border-bottom: solid 1px;">担当名</th>
                <td style="border-bottom: solid 1px;" colspan="7">{{ prodItem.staffName}}</td>
              </tr>
            </template>
            <template>
              <tr>
                <th style="border-bottom: solid 1px;">緊急連絡レベル</th>
                <td style="border-bottom: solid 1px;" colspan="8">
                  <span
                    v-if="data.anpyLevel"
                    :class="['tag',
                      {'is-red':data.anpyLevel  === '1'},
                      {'is-pink':data.anpyLevel  === '2'},
                      {'is-yellow':data.anpyLevel  === '3'},
                      {'is-green':data.anpyLevel  === '4'},
                      {'is-purple':data.anpyLevel  === '5'},
                      {'is-blue':data.anpyLevel  === '6'},
                      ]"
                  >{{data.anpyLevel | anpyLevelFilter}}</span>
                </td>
              </tr>
              <tr v-for="(item, index) in data.tels" v-bind:key="index">
                <th
                  style="border-bottom: solid 1px; border-top: solid 1px;"
                  rowspan="10"
                  v-if="index==0"
                >緊急連絡先</th>
                <td
                  style="border-bottom: solid 1px; border-top: solid 1px;"
                >{{selectValue(item.emergencyContactlList,item.emergencyContactFree)}}</td>
                <td
                  style="border-bottom: solid 1px; border-top: solid 1px;"
                >{{item.emergencyContactPhoneNumber}}</td>
                <th style="border-bottom: solid 1px; border-top: solid 1px; width:150px;">停電情報の配信希望</th>
                <td
                  style="border-bottom: solid 1px; border-top: solid 1px;"
                >{{item.selfArrow|selfArrowFilter}}</td>
              </tr>
              <tr>
                <th style="border-bottom: solid 1px;">Philips関係者</th>
                <td style="border-bottom: solid 1px; word-break: break-all;" colspan="5">
                  {{ data.anpyPhilps1 }}
                  <br />
                  {{ data.anpyPhilps2 }}
                  <br />
                  {{ data.anpyPhilps3 }}
                </td>
              </tr>
            </template>
            <tr>
              <th style="border-bottom: solid 1px;">メモ</th>
              <td style="border-bottom: solid 1px;" colspan="8">
                <b-input type="textarea" v-model="data.note" :readonly="true"></b-input>
              </td>
            </tr>
          </table>
        </table>
      </div>
    </div>
    <!-- 余白 -->
    <div style="height: 50px;" />
    <!-- 戻るボタン -->
    <div style="text-align:center;">
      <b-button
        v-on:click="back"
        class="button"
        type="is-primary"
        native-type="button"
        icon-left="keyboard-backspace"
      >戻る</b-button>
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px;" />
  </div>
</template>

<script>
import MapTemplate from "./AppMapView";
const MapForm = {
  props: ["marker"],
  components: {
    maps: MapTemplate
  },
  template: `
      <maps :markers="marker" />
    `
};
export default {
  name: "AppPatientDetail",
  methods: {
    back: function(event) {
      if (this.callUi=="AppDomesticTravel"){  // 国内旅行からの遷移の場合
        if (this.type=="edit"){               // 国内旅行検索一覧の「編集」ボタン呼出しの場合
          this.$router.push({
            name: "AppDomesticTravel",
            params: {
              type: this.type,
              domesticTravelCode: this.domesticTravelCode,
              status: this.statusRet,
              searchConditions: this.searchConditions,
              editFlg: this.editFlg
            }
          });
        } else {                            // 国内旅行検索一覧の「複写」ボタン呼出しの場合（編集以外は複写と判断（追加のケースはなし））
          this.$router.push({
            name: "AppDomesticTravel",
            params: {
              type: this.type,
              domesticTravelCode: this.domesticTravelCode,
              searchConditions: this.searchConditions
            }
          });
        }
      } else {
        this.$router.push({
          name: "AppPatientSearch",
          params: {
            searchConditions: this.searchConditions,
            patientSearchFlag: true
          }
        });
      }

    },
    prescriptionEdit: function(code, name, data) {
      // 処方値編集
      this.$router.push({
        name: "AppPrescriptionEdit",
        params: {
          productCode: data.productCode,
          productName: data.productName,
          patientCode: code,
          patientName: name,
          serialNumber: data.serialNumber,
          hospitalName: data.hospitalName,
          department: data.department,
          doctorName: data.doctorName,
          mainSetting: data.mainSetting,
          edit: false
        }
      });
    },
    gotoUrgentEdit: function(data) {
      // 緊急対応(患者コードで検索)
      var code = "";
      if (this.userInfo.roleId != 0) {
        for (var i = 0; i < data.productList.length; i++) {
          if (this.userInfo.officeCode == data.productList[i].officeCode) {
            code = data.code;
            break;
          }
          if (
            this.userInfo.referenceOfficeCodes.indexOf(
              data.productList[i].officeCode
            ) >= 0
          ) {
            code = data.code;
            break;
          }
        }
      } else {
        code = data.code;
      }
      this.$router.push({
        name: "AppUrgentList",
        params: { patientCode: code, isBeforePatient: true }
      });
    },
    getOfficeName: function(value, officeMaster) {
      // 営業所名取得処理
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    gotoTravelSchedule: function(data) {
      // 国内旅行対応(患者コードで検索)
      var isAdd = false;
      if (this.userInfo.roleId != 0) {
        for (var i = 0; i < data.productList.length; i++) {
          if (this.userInfo.officeCode == data.productList[i].officeCode) {
            isAdd = true;
            break;
          }
          if (
            this.userInfo.referenceOfficeCodes.indexOf(
              data.productList[i].officeCode
            ) >= 0
          ) {
            isAdd = true;
            break;
          }
        }
      } else {
        isAdd = true;
      }
      this.$router.push({
        name: "AppDomesticTravelSearch",
        params: {
          patientCode: data.code,
          patientInfo: data,
          isBeforePatient: true,
          isAdd: isAdd
        }
      });
    },
    gotoInspection: function(code, productCode, patientCode, serialNumber) {
      // 点検情報参照画面：製品コード,患者コード,シリアルNo
      this.$router.push({
        name: "AppInspectionView",
        params: {
          inspectionCode: code,
          productCode: productCode,
          patientCode: patientCode,
          serial: serialNumber,
          callUi: this.callUi
        }
      });
    },
    doShowGoogleMap: function(address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },
    getPatientInfoPOST: function(client) {
      return client.apis.apiPatient.getPatientInfoPOST({
        body: {
          code: this.code
        }
      });
    },
    getPatientInfoPOSTSuccess: function(result) {
      // WebAPI応答内容を画面に設定
      this.data = result.obj;
      if (this.data.birthday) {
        this.birthday = new Date(this.data.birthday);
      }
      // ANPY緊急連絡先の整形
      this.data["tels"] = [];
      for (var i = 1; i < 11; i++) {
        var relationship = "relationship" + String(i);
        var relationshipFree = "relationshipFree" + String(i);
        var relationshipPhoneNumber = "relationshipPhoneNumber" + String(i);
        var relationshipCallFlag = "relationshipCallFlag" + String(i);
        if (this.data[relationship] && this.data[relationship].length > 0) {
          this.data.tels.push({
            emergencyContactlList: this.data[relationship],
            emergencyContactFree: this.data[relationshipFree],
            emergencyContactPhoneNumber: this.data[relationshipPhoneNumber],
            selfArrow: this.data[relationshipCallFlag] ? "0" : "1"
          });
        }
      }
      if (this.data.tels.length < 5) {
        var cnt = 5 - this.data.tels.length;
        for (var j = 0; j < cnt; j++) {
          this.data.tels.push({});
        }
      }
    },
    getPatientInfoPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    selectValue: function(value, free) {
      if (value == "その他") {
        return free;
      }
      return value;
    }
  },
  data() {
    var data = [];
    var officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    var code = this.$route.params["code"];
    var searchConditions = this.$route.params["searchConditions"];
    var type = this.$route.params["type"];
    var domesticTravelCode = this.$route.params["domesticTravelCode"];
    var statusRet = this.$route.params["status"];
    var editFlg = this.$route.params["editFlg"];
    var callUi = this.$route.params["callUi"];
    return {
      data,
      officeMaster,
      inspectionItemModalActive: false,
      isShowGoogleMap: false,
      addressList: [],
      code,
      userInfo,
      searchConditions,
      type,
      domesticTravelCode,
      statusRet,
      editFlg,
      callUi
    };
  },
  filters: {
    officeFilter: function(value, officeMaster) {
      var officeElement = officeMaster.find(v => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
    directDestinationTypeFilter: function(value) {
      if (value === "0") {
        return "直送不可";
      } else if (value === "1") {
        return "患者宅";
      } else if (value === "2") {
        return "クリニック";
      } else if (value === "3") {
        return "ディーラー配送";
      } else {
        return "";
      }
    },
    genderFilter: function(value) {
      if (value === "M") {
        return "男性";
      } else if (value === "F") {
        return "女性";
      } else {
        return "";
      }
    },
    therapyFilter: function(value) {
      if (value === "0") {
        return "NPPV";
      } else if (value === "1") {
        return "TPPV";
      } else if (value === "2") {
        return "HFT";
      } else if (value === "3") {
        return "NPPV/HFT";
      } else if (value === "4") {
        return "TPPV/HFT";
      } else {
        return "";
      }
    },
    InfectionFilter: function(value) {
      if (value === "0") {
        return "無し";
      } else if (value === "1") {
        return "MRSA";
      } else if (value === "2") {
        return "HCV";
      } else if (value === "3") {
        return "HBV";
      } else if (value === "4") {
        return "Wa";
      } else if (value === "5") {
        return "その他";
      } else {
        return "";
      }
    },
    usageTimeFilter: function(value) {
      if (value === "0") {
        return "24時間";
      } else if (value === "1") {
        return "日中";
      } else if (value === "2") {
        return "夜間・睡眠時";
      } else if (value === "3") {
        return "労作時";
      } else {
        return "";
      }
    },
    anpyArrowFilter: function(value) {
      if (value + "" == "true") {
        return "許可";
      } else {
        return "禁止";
      }
    },
    selfArrowFilter: function(value) {
      if (value === "0") {
        return "希望";
      } else if (value === "1") {
        return "希望しない";
      }
    }
  },
  mounted: function() {
    var excuteApi = this.getPatientInfoPOST;
    var successCallBack = this.getPatientInfoPOSTSuccess;
    var errorCallBack = this.getPatientInfoPOSTError;
    // WebAPI Call
    this.apiCall(excuteApi, successCallBack, errorCallBack);
  },
  components: {
    "googleMap-form": MapForm
  }
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $success,
    $success-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $danger,
    $danger-invert
  )
);
</style>


// WEBPACK FOOTER //
// src/components/AppPatientDetail.vue